"use strict";

exports.__esModule = true;
exports.AlertValueThumbnail = AlertValueThumbnail;
var _react = _interopRequireDefault(require("react"));
var _Measures = require("../../Measures");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AlertValueThumbnail(_ref) {
  var _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    width = _ref.width,
    height = _ref.height;
  var value = "Alert";
  return /*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
    x: x,
    y: y,
    width: width,
    height: height,
    value: value
  });
}